import styled from "styled-components";

interface IStatusDiv {
  status?: string;
}
export const StatusDiv = styled.div<IStatusDiv>`
  ${(props) => {
    const status = props.status;
    let color, backgroundColor;
    if (status === "problem") {
      color = props.theme.colors.supportRed;
      backgroundColor =
        props.theme.colors.supportRed + props.theme.transparencies.p10;
    } else if (status === "warning") {
      color = props.theme.colors.blackTextBody;
      backgroundColor = props.theme.colors.supportYellow;
    } else if (status === "ok") {
      color = props.theme.colors.betterGreen;
      backgroundColor =
        props.theme.colors.betterGreen + props.theme.transparencies.p10;
    } else {
      color = props.theme.colors.gray;
      backgroundColor =
        props.theme.colors.gray72 + props.theme.transparencies.p20;
    }
    return `
      span {
        background-color: ${backgroundColor};
        color: ${color};
        font-size: 1.1rem;
        font-weight: 600;
        padding: 0.6rem;
      }
  `;
  }}
`;

export const StatusBar = styled.div`
  display: flex;
  flex-direction: row;
  position: relative;
`;

export const StatusSection = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
`;

interface IStatusAmount {
  status?: string;
}
export const StatusAmount = styled.div<IStatusAmount>`
  ${(props) => {
    const status = props.status;
    let backgroundColor;
    if (status === "problem") {
      backgroundColor =
        props.theme.colors.supportRed + props.theme.transparencies.p10;
    } else {
      backgroundColor = props.theme.colors.supportYellow;
    }
    return `
      span {
        background-color: ${backgroundColor};
        color: ${props.theme.colors.blackTextBody};
        font-size: 1.1rem;
        font-weight: 600;
        margin-left: 0.3rem;
        padding: 0.6rem;
        width: 1rem;
      }
  `;
  }}
`;

export const EmptyVolanteDetail = styled.div`
  ${(props) => `
    color: ${props.theme.colors.blackTextTitle};
    font-family: ${props.theme.fontFamilies.primaryFont};
  `}
  background-color: ${(props) => props.theme.colors.white};
  border-radius: 10px;
  column-gap: 1.5rem;
  display: flex;
  font-size: 1.4rem;
  font-weight: 500;
  padding: 1rem 2rem;
`;

interface IVolanteHeader {
  enableCheckbox?: any;
  amountReady?: any;
  disabled?: any;
}
export const VolanteHeader = styled.div<IVolanteHeader>`
  ${(props) => `
    color: ${props.theme.colors.blackTextTitle};
    font-family: ${props.theme.fontFamilies.primaryFont};
    grid-template-columns: ${
      props.enableCheckbox ? "repeat(9, 1fr)" : "repeat(9 ,1fr)"
    };
  `}
  background-color: ${(props) => props.theme.colors.white};
  border-radius: 10px;
  display: grid;
  font-size: 1.4rem;
  font-weight: 500;
  margin-bottom: 1rem;
  padding: 1rem 1.5rem;

  & > div {
    align-items: center;
    display: flex;
    justify-content: center;
  }

  .main-info-header {
    align-items: flex-start;
    flex-direction: column;
  }

  .main-info-header p {
    margin: 0;
  }

  .id {
    ${(props) => `
      color: ${props.theme.colors.primaryBlue};
    `}
    font-size: 1.4rem;
    font-weight: 600;
  }

  .entry-date {
    ${(props) => `
      color: ${props.theme.colors.gray};
    `}
    font-size: 1.4rem;
    font-weight: 500;
  }

  .amount {
    ${(props) =>
      !props.amountReady
        ? `
        color: ${props.theme.colors.gray};
        opacity: 0.38;
    `
        : null}
  }

  .clickable-element {
    cursor: ${(props) => (props.disabled ? "default" : "pointer")};
  }
`;

export const FlightInfo = styled.div`
  ${(props) => `
    background-color: ${props.theme.colors.primaryBlue};
    font-family: ${props.theme.fontFamilies.primaryFont};
  `}
  color: ${(props) => props.theme.colors.white};
  border-radius: 10px;
  display: grid;
  grid-template-columns: 3fr 2fr 2fr 2fr 1fr;
  font-size: 1.4rem;
  font-weight: 500;
  padding: 1rem 1.5rem;

  h2 {
    font-size: 1.3rem;
    font-weight: 600;
    margin: 0;
    opacity: 0.5;
  }

  p {
    margin-bottom: 0.5rem;
    margin-top: 0.5rem;
  }
  .icon {
    height: 4rem;
    width: 5rem;
  }
`;

export const VolanteDetail = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 1rem;
  margin-left: 3%;
`;

export const VolanteDescription = styled.div`
  ${(props) => `
    color: ${props.theme.colors.blackTextTitle};
    font-family: ${props.theme.fontFamilies.primaryFont};
  `}
  background-color: ${(props) =>
    props.theme.colors.primaryBlue + props.theme.transparencies.p10};
  border-radius: 10px;
  font-size: 1.4rem;
  font-weight: 500;
  margin-bottom: 1rem;
  padding: 1rem 1.5rem;
`;

export const MainButton = styled.button`
  ${(props) => `
    background-color: ${props.theme.colors.accentGreen};
    font-family: ${props.theme.fontFamilies.primaryFont};
  `}

  align-items: center;
  border: none;
  border-radius: 8px;
  color: ${(props) => props.theme.colors.white};
  cursor: pointer;
  display: flex;
  font-size: 1.4rem;
  font-weight: 700;
  min-height: 4.3rem;
  justify-content: center;
  width: 13.5rem;

  :disabled,
  [disabled] {
    background-color: ${(props) =>
      props.theme.colors.accentGreen + props.theme.transparencies.p20};
    cursor: initial;
  }
`;

export const DivDate = styled.div`
  .clickable-element .react-date-picker__wrapper {
    border: 0px solid white;
  }
`;
export const DivDropdown = styled.div`
  .volante-dropdown-select-style {
    border: 1px solid #ffffff;
  }
  .volante-dropdown-select-style:not(.p-disabled):hover {
    border-color: #ffffff;
  }
  .volante-dropdown-select-style:not(.p-disabled).p-focus {
    border-color: #ffffff;
    box-shadow: 0 0 0 0.2rem #ffffff;
  }
`;

interface IOptionTemplateVolante {
  color?: string;
  fontWeight?: string | number;
  marginBottom?: string;
  marginRight?: string;
}
export const OptionTemplateVolante = styled.div<IOptionTemplateVolante>`
  ${(props) => `
    color:${props.color ? props.color : "#08082B"};
    font-family: ${props.theme.fontFamilies.primaryFont};
    font-weight: ${props.fontWeight ? props.fontWeight : 600};;
    margin-bottom: ${props.marginBottom ? props.marginBottom : "0rem"};
    margin-right: ${props.marginRight ? props.marginRight : "0rem"};
  `}
  cursor: pointer;
  font-size: 1.4rem;
`;
